<template>
  <div>
    <ul class="mt-2 list-group">
      <li v-for="task in projectTasks" :key="task.id" class="list-group-item js-task-details-collapse-container" v-bind:class="{ 'bg-light': task.kind == 'comment' }">
        <QuickTask :task="task" :expanded="true" :singleView="true" />
      </li>
    </ul>
  </div>
</template>

<script>
import api from "api";
import QuickTask from "components/QuickTask";

export default {
  components: {
    QuickTask,
  },
  data() {
    return {
      task_id: this.$route.params.task_id,
      project: {}
    };
  },
  computed: {
    projectTasks: function(){
      return this.$store.state.tasks.filter(function (task){
        return (task.id == this.task_id)
      }, this)
    }
  }
};
</script>
